import { render, staticRenderFns } from "./SfOverlay.vue?vue&type=template&id=0d519774&functional=true&"
import script from "./SfOverlay.vue?vue&type=script&lang=ts&"
export * from "./SfOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./SfOverlay.vue?vue&type=style&index=0&id=0d519774&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports